import React, { useState, useEffect, useContext } from "react";
// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Calendar, InputText, InputTextarea, classNames } from "primereact";
import { confirmDialog } from "primereact/confirmdialog";


// ------------------ COMPONENTES DE BASE--------------------------
import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import Card from "../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../Base/Services/ToastService";

import { ObtenerSiguienteNoOrdenT } from "../../../../../API/Mantenimiento/OrdenesTrabajo/OrdenesTrabajoRequest";

const EncabezadoOrdenesTrabajo = ({
  values,
  handleInputChange,
  userSolicita,
  habilitar,
  setHabilitar,
  resetForm,
  detalles,
  guardarIngresosBodega,
  toast,
  setValues,
  getOrdenT,
  agregarNuevaFila,
  eliminarItemDetalle,
  setDetalles,
  addOC,
  setIngresoToShow,
  areas,
  types,
  sinActivo,
  setAbrirRequisaCompras,
  setAbrirRequisaMaterial,
  setShowRequisas
}) => {

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);


  const verificarCampos = () => {
    let err = false;
    if (!values.UserName) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar un Usuario Solicita.");
    } else if(!values.Area){
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar el área.");
    } else if (!values.Type) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar la categoría.");
    } else if (!values.Comentario) {
      err = true;
      toastShow(toast, "error", "Error", "Debe ingresar un comentario.");
    } 
    return !err;
  };

  const habilitarComponentes = () => {
    setHabilitar(true);
  };

  // OBTENER VALORES INICIALES PARA CREAR UNA NUEVA ORDEN DE TRABAJO
  const getInfoNew = async () => {
    setLoading(true);
    const noOrdenTempo = await ObtenerSiguienteNoOrdenT();

    const d = {
      IdEstado: 47,
      StatusName: "Solicitado",
      FechaCreado: new Date(),
      IdOrdenDeTrabajo: -100,
      NoOrdenTrabajo: noOrdenTempo[0].NoOrdenTrabajo,
      Comentario: "",
    };
    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  const nuevaOrdenT = () => {
    confirmDialog({
      message: "Esta seguro que desea crear una nueva orden",
      header: "Nuevo",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        resetForm();
        setDetalles([]);
        getInfoNew();
        setIngresoToShow(null)
        setHabilitar(true);
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  return (
    <div className="form-demo px-3 mb-2 mt-2">
      <div className="d-flex flex-column justify-content-center">
        <Card
          contenido={
            <div>
              <div className="d-flex flex-wrap align-items-start gap-1 mt-2">
                {/* No. Orden T */}
                <span className="p-inputgroup " style={{ maxWidth: 235 }}>
                  <span className=" field p-float-label">
                    <InputText
                      id="NoOrdenTrabajo"
                      name="NoOrdenTrabajo"
                      value={values?.NoOrdenTrabajo}
                      autoFocus
                      onChange={handleInputChange}
                      style={{ fontWeight: "bold" }}
                      onKeyDown={(e) => (e.keyCode === 13 ? getOrdenT() : null)}
                    />
                    <label htmlFor="NoOrdenTrabajo">No. Orden de Trabajo</label>
                  </span>

                  <Button
                    icon="pi pi-search"
                    type="button"
                    className="p-button-info "
                    onClick={() => getOrdenT()}
                    tooltip="Buscar"
                    tooltipOptions={{position: "top"}}
                  />
                </span>

                {/* Fecha Creado */}
                <span className="p-float-label">
                  <Calendar
                    id="FechaCreado"
                    name="FechaCreado"
                    disabled
                    value={values?.FechaCreado}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                  />
                  <label htmlFor="FechaCreado">Fecha Creación</label>
                </span>

                {/* Fecha Finalizada*/}
                <span className="p-float-label">
                  <Calendar
                    id="FechaFinalizada"
                    name="FechaFinalizada"
                    disabled
                    value={values?.FechaFinalizada}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                  />
                  <label htmlFor="FechaCreado">Fecha Finalizada</label>
                </span>

                {/* Estado */}
                <span className=" p-float-label">
                  <InputText
                    id="estado"
                    disabled
                    name="estado"
                    value={values?.StatusName}
                    style={{ width: "100%", padding: "6px 3px" }}
                  />
                  <label htmlFor="estado">Estado</label>
                </span>

                {/* Usuario Creacion */}
                <span className=" p-float-label">
                  <InputText
                    disabled
                    id="UserCreate"
                    name="UserCreate"
                    readOnly
                    value={values?.UserNameCreo || userAuth?.UserName}
                    autoFocus
                    style={{ width: "100%", padding: "6px 3px" }}
                  />
                  <label htmlFor="usuarioCSM">Usuario CSM</label>
                </span>

                {/* Usuario Solicita */}
                <AutoCompleteDropdown
                  enable={habilitar}
                  name={"UserName"}
                  value={values?.UserName}
                  items={userSolicita}
                  field={"UserName"}
                  label={"Usuario Solicita"}
                  handleInputChange={handleInputChange}
                />

                {/* Area */}
                <AutoCompleteDropdown
                  enable={habilitar}
                  name={"Area"}
                  value={values?.Area}
                  items={areas}
                  field={"Area"}
                  label={"Area"}
                  handleInputChange={handleInputChange}
                />

                {/* Tipo o Categoría */}
                <AutoCompleteDropdown
                  enable={habilitar && detalles?.length === 0}
                  name={"Type"}
                  value={values?.Type}
                  items={types}
                  field={"Type"}
                  label={"Categoría"}
                  handleInputChange={handleInputChange}
                />

                {/* Comentarios */}
                <span className=" p-float-label d-flex mt-2">
                  <InputTextarea
                    disabled={!habilitar}
                    id="Comentario"
                    name="Comentario"
                    value={values?.Comentario}
                    onChange={handleInputChange}
                    cols={100}
                    rows={2}
                    className={classNames(" block", "encabezado__contenido")}
                    style={{
                      width: "100%",
                      maxHeight: "3rem",
                      maxWidth: "72vh",
                      height: "3rem",
                    }}
                  />
                  <label
                    id="label_comentario"
                    htmlFor="Comentario"
                    className={classNames("encabezado__contenido")}
                  >
                    Comentario
                  </label>
                </span>
              </div>

              {/* --------------------------BOTONES-----------------------  */}
              <div className="d-flex flex-wrap gap-3 mb-2">
                <div className="groupEncabezado encabezado__contenido-Card d-flex gap-1 mt-4 flex-wrap justify-content-between">
                  <Button
                    icon="pi pi-plus"
                    disabled={!habilitar}
                    type="button"
                    className="p-button-info encabezado__herramienta-botones"
                    tooltip="Agregar Items"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    onClick={(e) => {
                      if (verificarCampos()) {
                        agregarNuevaFila();
                      }
                    }}
                    tabIndex={7}
                  />
                  <Button
                    icon="pi pi-save"
                    disabled={!habilitar || !detalles?.length > 0}
                    className="p-button-primary encabezado__herramienta-botones"
                    tooltip="Guardar"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{ marginLeft: 1 }}
                    onClick={(e) => {
                      if (verificarCampos()) {
                        guardarIngresosBodega();
                      }
                    }}
                  />
                  <Button
                    icon="pi pi-pencil"
                    type="button"
                    className="p-button-secondary  encabezado__herramienta-botones"
                    onClick={habilitarComponentes}
                    tooltip="Editar"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{ marginLeft: 1 }}
                  />
                  <Button
                    icon="pi pi-times"
                    type="button"
                    className="p-button-danger encabezado__herramienta-botones"
                    onClick={() => eliminarItemDetalle()}
                    tooltip="Cancelar"
                    disabled={!habilitar || !detalles?.length > 0}
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{ marginLeft: 1 }}
                  />

         
                  <Button
                    icon="pi pi-book"
                    type="button"
                    className="p-button-info  encabezado__herramienta-botones"
                    onClick={nuevaOrdenT}
                    tooltip="Nuevo"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{ marginLeft: 1 }}
                  />
        

                  <Button
                    icon="pi pi-sync"
                    type="button"
                    className="p-button-info encabezado__herramienta-botones"
                    onClick={() => getOrdenT()}
                    tooltip="Cargar"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{ marginLeft: 1 }}
                  />

                  {values?.IdOrdenDeTrabajo > 0 && (
                    <Button
                      icon="pi pi-shopping-cart"
                      tooltip="Requisa de Compra"
                      tooltipOptions={{ position: "top" }}
                      onClick={() => { 
                        setAbrirRequisaCompras(true)
                      }}
                    />
                  )}

                  {values?.IdOrdenDeTrabajo > 0 && (
                    <Button
                      icon="ri-building-4-line"
                      tooltip="Requisa de Material"
                      tooltipOptions={{ position: "top" }}
                      onClick={() => { 
                        setAbrirRequisaMaterial(true)
                      }}
                    />
                  )}

                  {values?.IdOrdenDeTrabajo > 0 && (
                    <Button
                      icon="pi pi-eye"
                      tooltip="Ver Requisas"
                      tooltipOptions={{ position: "top" }}
                      onClick={() => { 
                        setShowRequisas(true)
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default EncabezadoOrdenesTrabajo;
